"use client";

import { useEffect, useState } from "react";
import style from "@/styles/Footer.module.scss";
import { resetCookiePreferences } from "@/app/common/Utils";

export const ResetCookie = () => {
	const [resetCookie, setResetCookie] = useState(false);
	useEffect(() => {
		const consentRaw = localStorage.getItem("cookieConsent");
		if (!consentRaw) return;

		setResetCookie(true);
	}, []);

	useEffect(() => {
		const handler = (event: Event) => {
			const consentRaw = localStorage.getItem("cookieConsent");
			if (!consentRaw) return;

			setResetCookie(true);
		};

		window.addEventListener("cookiePreferencesChanged", handler);
		return () => window.removeEventListener("cookiePreferencesChanged", handler);
	}, []);

	const handleReset = () => {
		setResetCookie(false);
		resetCookiePreferences();
	};

	if (!resetCookie) {
		return null;
	}
	return (
		<li>
			<button onClick={() => handleReset()} className={style.resetCookieButton}>
				Cookies zurücksetzen
			</button>
		</li>
	);
};
